import { Box, Text, Flex, Button, Image } from 'rebass';
import useSWR from 'swr';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useWindowSize } from 'react-use';
import { getSWR } from 'utils/api';
import EditMilestone from './EditMilestone';
import bookCover from './assets/BackCover.png';
import bookCoverRight from './assets/BackCoverRight.png';
import duck from './assets/duck.png'
import babyBorn from './assets/babyBorn.png'
import useEntities from 'entities/hooks/use-entities';
import store from 'store';
import MilestonesFTUE from './MilestonesFTUE';
import PaymentBlocker from './PaymentBlocker';
import useHistory from 'app/hooks/history';
import { IoIosArrowBack } from 'react-icons/io';

const bookPreview = (fill = "#9B59B6") => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M18.125 3.12501C15.5921 3.1366 13.8267 3.45527 12.6392 4.02263C11.513 4.5607 10.8991 5.32445 10.625 6.33464V16.0311C12.0489 14.9777 14.232 14.375 18.125 14.375V3.12501ZM19.375 14.375C19.375 14.7065 19.2432 15.0244 19.0088 15.2588C18.7744 15.4932 18.4565 15.625 18.125 15.625C13.199 15.625 11.5058 16.6186 10.4883 17.8906C10.3697 18.0389 10.1899 18.125 10 18.125C9.81008 18.125 9.63029 18.0382 9.51172 17.8898C8.50105 16.6254 6.80029 15.625 1.875 15.625C1.49801 15.625 1.16777 15.4651 0.941571 15.1994C0.723464 14.943 0.625002 14.6174 0.625002 14.2993V3.12501C0.624694 2.96118 0.656986 2.7988 0.719403 2.64731C0.782118 2.49515 0.87403 2.35678 0.990399 2.24041L1.08155 2.1574C1.17663 2.07947 1.28323 2.01643 1.3973 1.96941C1.54952 1.90669 1.71281 1.87439 1.87744 1.87501L2.35921 1.88071C4.72867 1.92833 6.55579 2.25271 7.89958 2.8947C8.83239 3.34038 9.52557 3.93745 10 4.67774C10.4744 3.93745 11.1676 3.34038 12.1004 2.8947C13.5338 2.20989 15.5176 1.88669 18.1226 1.87501L18.2454 1.88071C18.3271 1.88847 18.4078 1.9043 18.4863 1.92791L18.6027 1.96941L18.7142 2.02149C18.7865 2.06004 18.8551 2.10544 18.9185 2.1574L19.0096 2.24041L19.0926 2.33155C19.1705 2.42663 19.2336 2.53323 19.2806 2.64731C19.343 2.7988 19.3753 2.96117 19.375 3.12501V14.375ZM1.875 14.2993C1.875 14.3368 1.88187 14.3612 1.88721 14.375C5.76997 14.3763 7.95382 14.9823 9.375 16.0319V6.33464C9.10089 5.32445 8.48704 4.5607 7.36084 4.02263C6.17333 3.45527 4.4079 3.1366 1.875 3.12501V14.2993Z" fill={fill} />
</svg>

const milestonesPreview = (fill = "#9B59B6") => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M18.3369 7.06663L13.264 6.32705L10.9967 1.72982C10.5904 0.910379 9.41332 0.899963 9.0036 1.72982L6.73624 6.32705L1.66332 7.06663C0.753597 7.19858 0.389014 8.3201 1.04874 8.96246L4.71887 12.5389L3.85082 17.5909C3.69457 18.5041 4.65638 19.1882 5.46193 18.7611L10.0001 16.3757L14.5383 18.7611C15.3439 19.1847 16.3057 18.5041 16.1494 17.5909L15.2814 12.5389L18.9515 8.96246C19.6112 8.3201 19.2467 7.19858 18.3369 7.06663ZM13.4932 11.9555L14.3161 16.7611L10.0001 14.4937L5.68415 16.7611L6.50707 11.9555L3.01401 8.55274L7.8404 7.85135L10.0001 3.47635L12.1598 7.85135L16.9862 8.55274L13.4932 11.9555Z" fill={fill} />
</svg>

const Options = [
  {
    label: 'Milestones',
    icon: (label) => milestonesPreview(label),
  },
  {
    label: 'Book Preview',
    icon: (label) => bookPreview(label),
  }
]

function RenderMileStone({ milestone, setMileStoneEdit }) {
  const { complete, startDate, title, id, statusIcon } = milestone;
  let day = '', month = '';
  if (startDate) {
    const [year, monthNum, dayNum] = startDate.split('-').map(Number);

    const dateObj = new Date(year, monthNum - 1, dayNum);

    day = dayNum;
    month = dateObj.toLocaleString('default', { month: 'short' });
  }

  return (
    <Box key={id} sx={{ textAlign: 'center', cursor: 'pointer', position: 'relative' }} onClick={() => setMileStoneEdit(milestone)}>
      {startDate && (<Box height={39} width={39} sx={{
        position: 'absolute',
        backgroundColor: '#fff',
        borderRadius: '50%',
        top: 0,
        left: ['15px', '55px'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      }}>
        <Text fontFamily="Poppins" color="#34495E" fontSize={'12.957px'} lineHeight={'11.878px'} fontWeight={600}>
          {day}<br /> {month}
        </Text>
      </Box>
      )}
      {statusIcon && (
        <Image src={statusIcon} alt="Milestone" style={{ width: 143, height: 143, mb: 8 }} />
      )}
      <Text fontFamily="Poppins" lineHeight="110%" fontWeight={400} color={complete ? '#0E0E0E' : '#737373'} fontSize={16} mb={2}>
        {title}
      </Text>
    </Box>
  );
}

const Milestones = () => {
  const { id: journalId } = useParams()
  const { width } = useWindowSize();
  const [editMilestone, setMileStoneEdit] = useState(null)
  const [selectedOption, setSelectedOption] = useState('milestones')
  const [showFTUE, setShowFTUE] = useState(false)
  const isMobile = width < 600;
  const { goBack } = useHistory();

  const { data: mainData, revalidate } = useSWR(`/v3/child_journals/${journalId}/milestones`, getSWR);

  const child_journals = useEntities('child-journals')
  let childJournal = child_journals[journalId]
  let day = '', month = '';
  if (childJournal?.['date-of-birth']) {
    const [year, monthNum, dayNum] = childJournal?.['date-of-birth'].split('-').map(Number);

    const dateObj = new Date(year, monthNum - 1, dayNum);

    day = dayNum;
    month = dateObj.toLocaleString('default', { month: 'short' });
  }

  
  const milestonesData = mainData?.data?.data.map(({
    attributes,
    relationships
  }) => ({
    id: attributes?.id,
    startDate: attributes?.['start-date'],
    statusIcon: attributes?.['status-icon'],
    title: attributes?.title,
    complete: attributes?.complete,
    storyId: relationships?.['story']?.data?.id,
    updatedAt: attributes?.['updated-at'],
    kind: attributes?.['milestone-kind'],
  })) || [];

  useEffect(() => {
    if (!store.get('milestone_ftui_watched'))
      setShowFTUE(true)
  }, []);

  const isDobExist = !!childJournal?.['date-of-birth'];

  const isMilestonePermitted = childJournal?.['child-journal-milestones-permitted']

  if (isMilestonePermitted === false)
    return <Box m={isMobile ? 0 : 2} id={"YEH CHECK KAROcheck" + `${isMobile}`}>
      <Box
        sx={isMobile ? { bg: '#fff', position: 'fixed', bottom: 0, left: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' } : {}}
        p={2}
      >
        <Flex
          height={40}
          width="min-content"
          justifyContent="space-around"
          alignItems="center"
          sx={{ borderRadius: 'medium', cursor: 'pointer' }}
          onClick={goBack}
        >
          <Text as={IoIosArrowBack} color="mineShaft" size={24} />
          <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={1} fontWeight={400} fontSize="15px">
            Back
          </Text>
        </Flex>
      </Box>
      <PaymentBlocker sku="by-feature-milestones" />
    </Box>

  if (editMilestone) {
    return <EditMilestone revalidate={revalidate} journalId={journalId} setMileStoneEdit={setMileStoneEdit} milestone={editMilestone} onAllMilestones={() => setMileStoneEdit(null)} />
  }

  return <Box m={width < 600 ? 2 : 4} mr={2}>
    {showFTUE && <MilestonesFTUE onClose={() => {
      store.set('milestone_ftui_watched', true)
      setShowFTUE(false)
    }} />}

    <Flex justifyContent={width < 600 ? 'center' : "space-between"} alignItems={width < 600 && "center"} mb={4}>
      <Text fontFamily="Bitter" color="#0E0E0E" fontSize={"30px"} letterSpacing="0.22px" lineHeight="165%">
        {selectedOption === 'milestones' ? 'Milestones' : 'Book Preview'}
      </Text>
      {width >= 600 ? (selectedOption === 'milestones' ? <Button height={44} py="unset" bg="transparent" color="#9B59B6" sx={{
        borderRadius: '23px',
        border: '1.5px solid #9B59B6',
        display: 'flex',
        alignItems: 'center',
      }}
        onClick={() => setSelectedOption('bookPreview')}
      >
        {bookPreview()}&nbsp;
        Book Preview</Button> :
        <Button height={44} py="unset" bg="transparent" color="#9B59B6" sx={{
          borderRadius: '23px',
          border: '1.5px solid #9B59B6',
          display: 'flex',
          alignItems: 'center',
        }}
          onClick={() => setSelectedOption('milestones')}
        >
          {milestonesPreview()}&nbsp;
          Milestones</Button>
      ) :
        <Flex
          bg="#fff"
          justifyContent="space-around"
          alignItems="center"
          p="17px 0px"
          sx={{
            position: 'fixed',
            bottom: 0,
            width: '100vw',
            zIndex: 999,
            border: '1.5px solid #F5EEF8'
          }}
        >
          {Options.map(({ icon, label }) => {
            const isOptionSelected = label.toLowerCase() === selectedOption;

            return (
              <Flex
                key={label}
                onClick={() => setSelectedOption(label.toLowerCase())}
                ml="24px"
                bg='white'
                sx={{ borderRadius: '100px', cursor: 'pointer' }}
              >
                {icon(isOptionSelected ? '#9B59B6' : '#64748B')}
                <Text ml={1} fontSize="16px" fontFamily="Poppins" fontWeight={500} lineHeight="20px" color={isOptionSelected ? '#9B59B6' : '#64748B'}>
                  {label}
                </Text>
              </Flex>
            );
          })}
        </Flex>}
    </Flex>
    {/* <Box my={4} sx={{ border: '0.5px solid #E2E8F0' }} /> */}
    <Text fontFamily="Poppins" color="#64748B" my={[2, 4]} textAlign="center" fontSize={16} letterSpacing="0.14px" lineHeight="165%">
      {selectedOption === 'milestones' ? 'Add dates to your baby’s milestone page' : 'Here’s what your Milestones pages will look like in the book'}
    </Text>
    {selectedOption === 'milestones' ? <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: width < 600 ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
        gap: 3,
        mt: 4,
        mb: 7
      }}
    >
      {milestonesData.filter(a => a.startDate).sort((a, b) => new Date(a.startDate) - new Date(b.startDate)).map(milestone => <RenderMileStone milestone={milestone} setMileStoneEdit={setMileStoneEdit} />)}
      {milestonesData.filter(a => !a.startDate).map(milestone => <RenderMileStone milestone={milestone} setMileStoneEdit={setMileStoneEdit} />)}

    </Box> : <Box>
      <Flex m="auto" mt={4} justifyContent="center" alignItems="center" >
        <Flex sx={{
          width: '50vw',
          maxWidth: '450px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          // backgroundImage: `url(${bookCover})`,
          boxShadow: '0 8.522px 8.522px 0 rgba(0, 0, 0, 0.10), -8.522px 0 8.522px 0 rgba(0, 0, 0, 0.10) inset'
        }}>
          <Image src={bookCover} sx={{ zIndex: -1 }} />
          {isDobExist ? <Flex flexDirection="column" alignItems="center" sx={{ position: 'absolute' }}>
            <Text fontFamily="Dancing Script" color="#885A00" fontSize={["26.384px", "42px", "42px", "68.992px"]} letterSpacing={["0.324px", "0.69px"]} lineHeight="100%">
              {childJournal?.['first-name-possessive']}
            </Text>
            {!(day || month) && <Image src={duck} alt="Book Cover" sx={{ width: [88.897, 374.287], height: [60, 229.018], mt: 3 }} />}
            <Text fontFamily="Dancing Script" color="#885A00" fontSize={["26.384px", "42px", "42px", "68.992px"]} letterSpacing={["0.324px", "0.69px"]} lineHeight="100%">
              Milestones
            </Text>
            <Image src={babyBorn} alt="Book Cover" sx={{ width: [70, '150.248px'], height: [70, '150.248px'], my: 3 }} />
            {(day || month) && <Text textAlign="center" fontFamily="Cabin" color="#0E0E0E" fontSize={["6.438px", "12px", "12px", "13.734px"]} lineHeight="110%">
              Baby Born<br />
              <br />
              {day} {month}
            </Text>}
          </Flex> : <Flex flexDirection="column" alignItems="center" sx={{ position: 'absolute' }}>
            <Text fontFamily="Dancing Script" color="#885A00" fontSize={["26.384px", "42px", "42px", "68.992px"]} letterSpacing={["0.324px", "0.69px"]} lineHeight="100%">
              {childJournal?.['first-name-possessive']}
            </Text>
            <Image src={duck} alt="Book Cover" sx={{ width: [88.897, 374.287], height: [60, 229.018], mt: 3 }} />
            <Text fontFamily="Dancing Script" color="#885A00" fontSize={["26.384px", "42px", "42px", "68.992px"]} letterSpacing={["0.324px", "0.69px"]} lineHeight="100%">
              Milestones
            </Text>
          </Flex>}
        </Flex>
        <Flex sx={{
          width: '50vw',
          maxWidth: '450px',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          boxShadow: '0 8.522px 8.522px 0 rgba(0, 0, 0, 0.10), 8.522px 0 8.522px 0 rgba(0, 0, 0, 0.10) inset'
        }}>
          <Image src={bookCoverRight} sx={{ zIndex: -1 }} />
          <Flex flexDirection="column" alignItems="center" sx={{ position: 'absolute' }}>
            <Box
              sx={{
                position: 'relative',
                display: 'grid',
                gridTemplateColumns: width < 600 ? 'repeat(4, 35px)' : 'repeat(4, 75px)',
                gap: ['2px', '8px'],
                padding: '47px 0 46.597px 0',
              }}
            >
              {milestonesData.filter(a => a.startDate).sort((a, b) => new Date(a.startDate) - new Date(b.startDate)).filter(({ kind }) => isDobExist ? kind !== "birth" : true).map((milestone => {
                const { complete, startDate, title, id, statusIcon } = milestone;
                let day = '', month = '';
                if (startDate) {
                  const [year, monthNum, dayNum] = startDate.split('-').map(Number);

                  const dateObj = new Date(year, monthNum - 1, dayNum);
                  day = dayNum;
                  month = dateObj.toLocaleString('default', { month: 'short' });
                }
                return (
                  <Box key={id} sx={{ textAlign: 'center', position: 'relative' }} >
                    {startDate && (<Box height={['9.535px', 20]} width={['9.535px', 20]} sx={{
                      position: 'absolute',
                      backgroundColor: '#fff',
                      borderRadius: '50%',
                      top: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    }}>
                      <Text fontFamily="Poppins" color="#34495E" fontSize={['3.195px', '6.807px']} lineHeight={['2.929px', '6.24px']} fontWeight={500}>
                        {day}<br /> {month}
                      </Text>
                    </Box>
                    )}
                    {statusIcon && (
                      <Image src={statusIcon} alt="Milestone" sx={{ width: [25, 65], height: [25, 65] }} />
                    )}
                    <Text fontFamily="Poppins" lineHeight="110%" fontWeight={400} color={complete ? '#0E0E0E' : '#737373'} fontSize={['3.238px', '6.899px']} mb={['4px', 1]}>
                      {title}
                    </Text>
                  </Box>
                );
              }))}
            </Box>
          </Flex>
        </Flex>
      </Flex>
      <Text fontFamily="Poppins" color="#737373" my={4} textAlign="center" fontSize={16} letterSpacing="0.14px" lineHeight="165%">
        When you’re ready to print your book, you’ll have the option of including or excluding these pages.
      </Text>
    </Box>}
  </Box>
};

Milestones.propTypes = {

};

export default Milestones;
